import * as React from "react";
export const AccountServiceContext = React.createContext(undefined);
